import request from "@/utils/http"


export const login = (code, data) => {
  return request.post(`users/login/${code}`, data)
}